import { Maybe } from '@/utils/types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'brand_landing'
type ItemType = 'ContentEpisode' | 'ContentLivestream' | 'ContentSeries' | 'ContentMovie' | 'ContentSpecial'

/**
 * Interaction builder for items in brand landing page tabs
 * Used for tracking user interactions with content in episodes, extras, and franchise/collection tabs
 */
export class BrandLandingTabItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ItemType>; attribution: unknown }) {
    super(item)
  }
}
